import { handleKeyPress, tw } from "@/utils";
import { StatusProgressBar } from "../../components/StatusProgressBar/StatusProgressBar";
import { SearchInput } from "../../components/tableComponents/SearchInput/SearchInput";
import Filter from "@/assets/filter.svg?react";
import { PatientListCard } from "./PatientListCard";
import { PatientDetail } from "./PatientDetail";
import { useNavigate, useParams } from "react-router";
import { useWindowStore } from "@/store/WindowWidth";
import { useGetHospitalsResource } from "./api";
import { useEffect, useState } from "react";
import { DelayRenderWrapper } from "@/components/DelayRenderWrapper/DelayRenderWrapper";
import Loader from "@/components/Loader";

interface TransferringProps {
  // props 정의
}

export const Transferring = (props: TransferringProps) => {
  const {} = props;
  const navigate = useNavigate();
  const { requestId } = useParams();

  const [searchText, setSearchText] = useState<string>("");
  const [searchParamsText, setSearchParamsText] = useState<string>("");

  const { data, isSuccess, isLoading, isError } =
    useGetHospitalsResource(searchParamsText);

  const width = useWindowStore((state) => state.width);
  const isResponse = width < 1600;

  useEffect(() => {
    if (!requestId && isSuccess && data.result.data.length !== 0) {
      navigate(`/transferring/${data.result.data[0].requestId}`);
    }
  });

  return (
    <div className="w-full h-full">
      <header
        className={tw(
          "flex items-center justify-between w-full h-[76px] bg-white px-[30px]",
          "border-solid border-b-[1px] border-gray-g50"
        )}
      >
        <div className="flex items-center gap-[10px]">
          <div className="text-2xl font-semibold text-gray-g400">
            현재 이송 중
          </div>
          <div className="text-base font-regular text-gray-g100">
            현재 나의 기관으로 이송 중인 환자입니다.
          </div>
        </div>
        {requestId && <StatusProgressBar />}
      </header>
      <div className="flex w-full h-[calc(100%-76px)]">
        {/* 좌측 환자 목록 */}
        <div
          className={tw(
            "w-[33%] max-w-[540px] min-w-[400px] h-full bg-white",
            isResponse && "w-[45%]"
          )}
        >
          <div className="flex items-center h-[42px] mx-[20px] mt-[20px]">
            <div className="grow">
              <SearchInput
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                fullWidth
                placeholder="환자 검색"
                onKeyDown={handleKeyPress("Enter", () => {
                  setSearchParamsText(searchText);
                })}
                onSearch={() => {
                  setSearchParamsText(searchText);
                }}
              />
            </div>
            {/* <button
              className={tw(
                "flex items-center justify-center",
                "w-[48px] h-full ml-[10px] bg-white rounded-[8px]",
                "border-solid border-[1px] border-gray-g50"
              )}
              onClick={() => {
                window.alert("준비 중입니다.");
              }}
            >
              <Filter className="w-[13px] h-[16px] fill-gray-g300" />
            </button> */}
          </div>
          <div className="flex flex-col items-center gap-[14px] w-full h-[calc(100%-82px)] mt-[20px] overflow-auto px-[20px] pb-[20px]">
            {isError && <div>Error</div>}
            {isLoading && (
              <DelayRenderWrapper delay={200}>
                <Loader />
              </DelayRenderWrapper>
            )}
            {isSuccess &&
              (data.result.data.length == 0 ? (
                <div className="text-base font-semibold text-gray-g300">
                  현재 이송 중인 환자가 없습니다.
                </div>
              ) : (
                data?.result.data.map((data) => <PatientListCard data={data} />)
              ))}
          </div>
        </div>
        <div className="grow h-full p-[20px]">
          {requestId ? <PatientDetail /> : <></>}
        </div>
      </div>
    </div>
  );
};
